<template>
  <div class="bg-white shadow-lg rounded-lg">
    <div class="p-10">
      <div class="pb-2 mb-4 border-b border-gray-200">
        <h2 class="text-gray-800 text-2xl font-medium">Show Factory</h2>
      </div>
      <div class="md:flex gap-6">
        <div class="md:w-1/2 mb-4">
          <label for="factory_name" class="label-control">Factory Name <span class="text-red-600">*</span></label>
          <input id="factory_name" ref="factory_name" type="text" v-model="factoryName" maxlength="255" class="form-control" autofocus>         
        </div>
        <div class="md:w-1/2 mb-4">
          <label for="factory_code" class="label-control">Factory Code <span class="text-red-600">*</span></label>
          <input id="factory_code" type="text" v-model="factoryCode" class="form-control">
        </div>
      </div>         
      <div class="md:flex gap-6">
        <div class="w-full mb-4">
          <label for="address" class="label-control">Address</label>
          <textarea id="address" v-model="address" class="form-control" rows="5"></textarea>                  
        </div>
      </div>
      <div class="md:flex gap-6">
        <div class="md:w-1/2 mb-4">
          <label for="city" class="label-control">City</label>
          <input id="city" type="text" v-model="city" class="form-control">
        </div>
        <div class="md:w-1/2 mb-4">
          <label for="country" class="label-control">Country</label>
          <input id="country" type="text" v-model="country" class="form-control">          
        </div>
      </div>
      <!-- CALL FACTORY CONTACTS -->
      <FactoryContact class="mb-10" />      
      <div class="md:flex gap-4 mt-4 mb-2">
        <button :disabled="isLoading" type="button" @click="goBack()" class="btn btn--secondary" alt="Back" title="Back">
          <BackIcon>
            <span class="ml-2 md:block hidden">Back</span>
          </BackIcon>              
        </button>
      </div>                                                  
    </div>    
  </div>
</template>

<script>
import factoryServices from '@/services/factory/factoryServices'
import BackIcon from '../../icons/BackIcon'
import FactoryContact from '../factory/Contact'

export default {
  name: 'ShowFactory',
  components: {
    BackIcon,
    FactoryContact
  },
  data(){
    return {
      factoryName: '',
      factoryCode: '',
      address: '',
      city: '',
      country: '',
      record: [],
      isLoading: false,
      toastedOptions: {
        position: "top-right", 
        duration : 5000,
        action: {
          text: 'x',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          }
        }  
      }      
    }
  },
  methods: {
    async fetchData(){
      try {
        const id = this.$route.params.id
        const response = await factoryServices.fetchById(id)
        if (response.data.status === 'success') {
          this.record = response.data.data

          this.factoryName = this.record.factory_name
          this.factoryCode = this.record.factory_code
          this.address = this.record.address
          this.city = this.record.city
          this.country = this.record.country
        } else {
          /* THROW ERROR MESSAGES */
          this.$toasted.error(response.data.message, this.toastedOptions)            
        }
      } catch (error) {
        console.log(error)
      }
    },
    goBack() {
      window.history.length > 1 ? this.$router.back() : this.$router.push('/factories')
    }       
  },
  created(){
    this.fetchData()
  }
}
</script>